import clsx from 'clsx'

export default function Card({ children, className, ...props }) {
  return (
    <div className={clsx('bg-white rounded-lg shadow-md overflow-hidden', className)} {...props}>
      {children}
    </div>
  )
}

/*
 * 横向留白用 gutter 令牌（tailwind.config，16px→24px 连续缩放），纵向固定不缩 ——
 * 小屏要把宽度让给内容，但收紧纵向没有收益、只让卡片发挤。上限 24px = 原 p-6。
 * 写成 class 而非内联 style：多处列表页传 className="p-0" 清零内边距，内联会盖掉它。
 * index.css 的 .card-header/.card-body 是同一套值，改这里要同步过去。
 */
export function CardHeader({ children, className, ...props }) {
  return (
    <div className={clsx('px-gutter py-4 border-b border-gray-200 bg-gray-50', className)} {...props}>
      {children}
    </div>
  )
}

export function CardBody({ children, className, ...props }) {
  return (
    <div className={clsx('px-gutter py-6', className)} {...props}>
      {children}
    </div>
  )
}

Card.Header = CardHeader
Card.Body = CardBody
